import { Component, InjectReactive, Watch } from 'vue-property-decorator'
import { Nullable, OneOrMore } from '@internal-libraries/kheops-ui-lib'
import { ScreenControlTemplateData } from '../../../Types/ScreenControlTemplateData'
import { ScreenControlDataTypeData } from '../../../Types/ScreenControlDataTypeData'
import ClvrScreenControlCellAbstract from './ClvrScreenControlCellAbstract'

@Component({
    components: {},
})
export default class ClvrScreenControlDataCell extends ClvrScreenControlCellAbstract {
    @InjectReactive({ from: 'template', default: null }) private readonly template!: Nullable<ScreenControlTemplateData>

    private dataTypeMap = new Map<string, ScreenControlDataTypeData>()

    @Watch('template', { immediate: true, deep: true })
    public watchTemplateChange() {
        this.dataTypeMap = new Map()
        this.template?.dataTypes?.forEach(dataType => {
            this.dataTypeMap.set(dataType.name, dataType)
            dataType.dataTypeChildren?.forEach(dataTypeChild => {
                this.dataTypeMap.set(dataTypeChild.name, dataTypeChild)
            })
        })
    }

    public getDataTypeVisibility(names: OneOrMore<string>): boolean {
        return (Array.isArray(names) ? names : [names]).every(name => {
            return this.dataTypeMap.get(name)?.enable
        })
    }
}
